import { Gender } from "./Gender";

export interface Character {
  identifier: string;
  fullName: string;
  gender: Gender;
  profilePhotoURL?: string;
  faceCenteredProfilePhotoURL?: string;
  isActive: boolean;
  archetype: string;
  shortBio: string;
  vibeTags: string[];
}

export class CharacterHelper {
  static readonly IDENTIFIER_PREFIX = "char_";

  /**
   * URL for small circular avatars — the square face crop reads far better
   * when shrunk than the full portrait. Zoomed/full-bleed views keep using
   * profilePhotoURL.
   */
  static getAvatarPhotoURL(
    character: Pick<
      Character,
      "profilePhotoURL" | "faceCenteredProfilePhotoURL"
    >,
  ): string | undefined {
    return character.faceCenteredProfilePhotoURL ?? character.profilePhotoURL;
  }

  static isCharacterIdentifier(identifier: string | undefined | null): boolean {
    return (
      typeof identifier === "string" &&
      identifier.startsWith(CharacterHelper.IDENTIFIER_PREFIX)
    );
  }

  /** First word of the character's full name; the full name when it has no spaces. */
  static firstName(character: Pick<Character, "fullName">): string {
    return character.fullName.trim().split(/\s+/)[0] || character.fullName;
  }
}
